import {
  StackActions,
  DrawerActions,
  createNavigationContainerRef,
} from "@react-navigation/native";
import { Linking } from "react-native";

export const navigationRef = createNavigationContainerRef();

// export function navigate() {
//   if (navigationRef.isReady()) {
//     navigationRef.navigate();
//   }
// }

// navigator methods .....................

export const nav = navigationRef.navigate;
export const dispatch = navigationRef.dispatch;

// utils
export const _goToBack = () => navigationRef.goBack();
export const _goToRoot = () => dispatch(StackActions.popToTop());

// splash
export const _goToHomeStack = () =>
  dispatch(StackActions.replace("home_stack"));
export const _goToRegisterStack = () =>
  dispatch(StackActions.replace("register_stack"));
export const _goToLoginStack = () =>
  dispatch(StackActions.replace("login_stack"));

// auth
export const _goToVerifyCode = () => nav("verify_code");

// company
export const _goToCategory = () => nav("category");
// export const _goToCategory = (params: CategoryRouteT) =>
//   nav("category", params);
export const _goToProducts = (params: ProductsRouteT) =>
  nav("products", params);

// cart
export const _goToCart = () => nav("cart");

// order
export const _goToOrders = () => nav("orders");
export const _goToOrderDetails = (id: number, company: string) =>
  nav("order_details", { id, company });

// others
export const _goToProfile = () => nav("profile");
export const _goToContactUs = () => nav("contact_us");
export const _goToAboutUs = () => nav("about_us");

// drawer
export const _openDrawer = () => dispatch(DrawerActions.toggleDrawer());

export const _closeDrawer = () => dispatch(DrawerActions.closeDrawer());
export const _goToItsaWebSite = () => Linking.openURL("https://www.itsaco.ir/");

export const _goToTest = () => nav("test");
